import { useExperiment } from "@hopper-b2b/experiments";
import { useI18nContext } from "@hopper-b2b/i18n";
import { EXPERIMENTS } from "../../../App";
import Insurance from "../../../assets/client/uv/insurance-with-background.svg?react";
import styles from "./styles.module.scss";

const FlightConfirmationTravelInsuranceIncluded = () => {
  const { t } = useI18nContext();

  const enableTravelInsurance = useExperiment(
    EXPERIMENTS.NUBANK_TRAVEL_INSURANCE
  );

  return enableTravelInsurance ? (
    <div className={styles.FlightConfirmationTravelInsuranceIncluded}>
      <div className="content">
        <h4 className="title">{t("ultravioletaTravelInsurance.title")}</h4>
        <p>{t("ultravioletaTravelInsurance.rightToInsuranceEmail")}</p>
      </div>
      <Insurance className="icon" />
    </div>
  ) : null;
};

export default FlightConfirmationTravelInsuranceIncluded;
